<template>
  <modal
    width="400"
    :name="'profile'"
    :adaptive="true"
    :scrollable="true"
    :height="'auto'"
  >
    <card>
      <div class="mb-2">
        <button
          @click="$modal.hide('profile')"
          class="btn btn-danger btn-sm btn-icon"
        >
          <span class="ti-close"></span> {{ "back" | setText("Назад") }}
        </button>
      </div>
      <h6>{{ "account_data" | setText("Данные аккаунта") }}</h6>
      <br />
      <form>
        <fg-input
          type="text"
          max="191"
          name="last_name"
          label="Ваша фамилия"
          v-model="last_name"
          placeholder=""
        ></fg-input>
        <fg-input
          type="text"
          max="191"
          name="first_name"
          label="Ваше имя"
          v-model="first_name"
          placeholder=""
        ></fg-input>
        <br />
        <p-button
          class="w-100 mb-3"
          type="warning"
          round
          @click.native.prevent="save('profile')"
          >{{ "save" | setText("Сохранить") }}</p-button
        >
      </form>
      <hr />
      <h6>{{ "change_password" | setText("Изменить пароль") }}</h6>
      <br />
      <form>
        <fg-input
          type="password"
          name="password"
          max="191"
          label="Новый пароль"
          v-model="password"
          placeholder=""
        ></fg-input>
        <fg-input
          type="password"
          max="191"
          name="password_confirmation"
          label="Повторите новый пароль"
          v-model="password_confirmation"
          placeholder=""
        ></fg-input>
        <br />
        <p-button
          class="w-100 mb-3"
          type="warning"
          round
          @click.native.prevent="save('password')"
          >{{ "save" | setText("Сохранить") }}</p-button
        >
      </form>
    </card>
  </modal>
</template>
<script>
import { errorNotify } from "@/plugins/functions";
import { mapState } from "vuex";
export default {
  created() {
    if (this.user) {
      this.first_name = this.user.first_name;
      this.last_name = this.user.last_name;
    }
  },
  methods: {
    save(type = "profile") {
      let fileds = {};

      if (type == "profile") {
        fileds["first_name"] = this.first_name;
        fileds["last_name"] = this.last_name;
      } else if (type == "password") {
        fileds["password"] = this.password;
        fileds["password_confirmation"] = this.password_confirmation;
      }

      this.$loading(true);
      this.$http
        .post(`profile`, fileds)
        .then((response) => {
          this.$notify({
            title: this.$store.state.text["success"],
            message: this.$store.state.text["data_changed"],
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });

          this.$store.dispatch("setUser", response.data.data);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      first_name: "",
      last_name: "",
      password: "",
      password_confirmation: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
};
</script>
